import Comment from './Comment.container';
export default Comment;
